export default "__VITE_ASSET__Dq2P4byC__"